import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const OptionsWrapper = Styled.article`
display: inline-block;
background-color: ${color.white};
border-radius: 4px;
padding: 1rem .4rem;
`;

const Option = Styled.span`
position: relative;    
display: inline-flex;
flex-direction: column;
align-items:center;
justify-content:center;
text-align:center;
`;

const Radio = Styled.input.attrs(({ id }) => ({
  type: 'radio',
  id: id,
  name: 'options',
}))`
position: absolute;
top:0;
left:0;
width: 100%;
height: 100%;
cursor: pointer;
opacity: 0;
&:checked ~ *{background-color: ${color.secondaryAlt}}
&:hover ~ *{background-color: ${color.lightAlt}}
`;

const OptionValue = Styled.span`
padding: .8rem 2.4rem;
background: ${color.white};
border-radius: 4px;
text-transform: capitalize;
margin: 0 .5rem;
font-weight: bold;
`;

const Thumbnail = Styled.span`
display: block;
height:6rem;
width:6rem;
overflow: hidden;
border-radius: 100rem;
background-color: ${color.primary};
img{width: 100%; height: 100%;object-fit: cover};
`;

const SelectThumbnail = (props) => {
  const { options, onSelect } = props;
  return (
    <OptionsWrapper>
      {options.map(({ label, value, image }) => (
        <Option key={label}>
          <Radio value={value} onClick={onSelect} />
          <OptionValue>
            <Thumbnail>
              <img src={image} alt={label} />
            </Thumbnail>
            {label}
          </OptionValue>
        </Option>
      ))}
    </OptionsWrapper>
  );
};

export default SelectThumbnail;
